var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-podcast"},[_c('iframe',{staticClass:"podigee-podcast-player",attrs:{"src":'https://cdn.podigee.com/podcast-player/podigee-podcast-player.html?configuration=' +
        _vm.podcast +
        '/embed?context=external'}})])}
var staticRenderFns = []

export { render, staticRenderFns }